module.exports = __webpack_public_path__ + "img/speech.5517bf0e.png";